/**
 * API Configuration Utility
 * Centralized configuration for API base URLs across development and production environments
 */

/**
 * Determine API base URL based on environment
 * 
 * @returns The appropriate API base URL for the current environment
 */
export const getApiBase = (): string => {
  // Check if we have an explicit API base URL from environment
  const envApiBase = (import.meta as any)?.env?.VITE_API_BASE_URL;
  if (envApiBase) {
    return envApiBase;
  }
  
  // In development, use relative path to leverage Vite proxy
  if (import.meta.env.DEV) {
    return '';
  }
  
  // In production, use the production API
  return 'https://api.motivsuite.com';
};

/**
 * Get the full API URL for an endpoint
 * 
 * @param endpoint - The API endpoint (e.g., '/auth/me')
 * @returns The full API URL
 */
export const getApiUrl = (endpoint: string): string => {
  const base = getApiBase();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${base}/api/v1${cleanEndpoint}`;
};

/**
 * Debug information for API configuration
 * 
 * @returns Object containing API configuration details
 */
export const getApiDebugInfo = () => {
  return {
    apiBase: getApiBase(),
    isDev: import.meta.env.DEV,
    envApiBase: (import.meta as any)?.env?.VITE_API_BASE_URL,
    nodeEnv: import.meta.env.MODE
  };
};
